<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="company_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_company_id')">
                            <b-form-input v-model="formData.company_id" type="number" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="company_name" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('company_name')">
                            <b-form-input v-model="formData.name" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="address" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('address')">
                            <b-form-input v-model="formData.address" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="staff_count" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_staff_count')">
                            <b-form-input v-model="formData.staff_count" type="number" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="status" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('status')">
                            <b-form-select v-model="formData.status" :options="statusOptions" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="description" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('description')">
                            <b-form-textarea v-model="formData.description" rows="3" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" :disabled="formLoading" @click="update">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
    import CoopCompanyService from '@/services/CoopCompanyService';

    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        },
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                formLoading: false,
                formData: {
                    company_id: null,
                    name: null,
                    address: null,
                    staff_count: null,
                    status: 'active',
                    description: null
                },
                statusOptions: [
                    {value: 'active', text: this.$t('active')},
                    {value: 'passive', text: this.$t('passive')}
                ]
            }
        },
        created() {
            this.get(this.formId);
        },
        methods: {
            get(id) {
                CoopCompanyService.get(id)
                    .then(response => {
                        this.formData = response.data.data;
                    })
                    .catch((error) => {
                        this.showErrors(error, null);
                    });
            },
            async update() {
                const isValid = await this.$refs.formModalValidate.validate();

                if (isValid) {
                    this.formLoading = true;

                    CoopCompanyService.update(this.formId, this.formData)
                        .then(response => {
                            this.$toast.success(this.$t(response.data.message));
                            this.$emit('actionSuccess', true);
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.formModalValidate);
                        })
                        .finally(() => {
                            this.formLoading = false;
                        });
                }
            }
        }
    }
</script>
